var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1018,
    height: 856,
    viewBox: "0 0 1018 856",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1016.59 119.444C998.181 -57.4608 906.79 20.2926 763.719 5.95892C642.804 -6.15505 505.674 115.545 385.964 173.827C131.177 297.872 18.3774 261.716 1.82233 439.509C-18.3433 656.1 137.482 830.913 314.154 850.54C534.995 875.075 610.468 803.643 700.373 751.864C790.278 700.085 806.653 592.063 771.209 458.137C735.765 324.211 1034.99 296.349 1016.59 119.444Z",
    fill: "#FAEACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.73d057b3a807a230c258069f9ff5ecf8.svg";
export { ForwardRef as ReactComponent };